/* esm.sh - react@18.3.1 */
export * from "/*react@18.3.1/esnext/react.mjs";
export { default } from "/*react@18.3.1/esnext/react.mjs";
